import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { imgPath } from '~src/commonInfra/utils/ImgUrl';

export type DeleteDomainButtonProps = Readonly<{
    onClick: () => void;
}>;

export function DeleteDomainButton(props: DeleteDomainButtonProps) {
    return (
        <ButtonWidget
            testId="delete-domain-button"
            buttonType={ButtonType.Icon}
            onClick={props.onClick}
        >
            <img src={imgPath('trash_14px_small.svg')} alt={''} />
        </ButtonWidget>
    );
}
